// "Safari on iPhone" from a browser's user agent, for the device lists in User
// Management and the Commercial Portal page.
export const deviceName = (agent) => {
  if (!agent) return 'Unknown device';
  const browser = /Edg\//.test(agent) ? 'Edge'
    : /CriOS\/|Chrome\//.test(agent) ? 'Chrome'
      : /FxiOS\/|Firefox\//.test(agent) ? 'Firefox'
        : /Safari\//.test(agent) ? 'Safari'
          : /iPhone|iPad/.test(agent) ? 'Home-screen app'
            : 'Browser';
  const system = /iPhone/.test(agent) ? 'iPhone' : /iPad/.test(agent) ? 'iPad' : /Android/.test(agent) ? 'Android'
    : /Mac OS X/.test(agent) ? 'Mac' : /Windows/.test(agent) ? 'Windows' : /Linux/.test(agent) ? 'Linux' : '';
  return system ? `${browser} on ${system}` : browser;
};
